/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton, Stack } from '@mui/material';
import { GridToolbarColumnsButton } from '@mui/x-data-grid-pro';
import { Localization } from 'connex-cds';

export const TableFooterContent = ({ retrieved = 0, refetch = () => {}, isLoadingOrRefetching = false }) => {
  const translateMessage = Localization.useTranslateMessage();

  return (
    <>
      <Stack className="selection-wrapper">
        <GridToolbarColumnsButton
          data-testid="columns-selector"
          className="columns-button"
          disabled={isLoadingOrRefetching}
        />
      </Stack>

      <Stack className="records-wrapper">
        <p data-testid="record-count" className="count-total truncate">
          <span>
            {isLoadingOrRefetching
              ? translateMessage('gridFooter_loading')
              : `${translateMessage('gridFooter_retrieved')} ${retrieved}`}
          </span>
        </p>

        <IconButton
          data-testid="refresh-button"
          className="refresh-button"
          onClick={refetch}
          disabled={isLoadingOrRefetching}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Stack>
    </>
  );
};
